var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCostav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 572,
    height: 572,
    viewBox: "0 0 572 572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "costav",
    transform: "translate(-155 -92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_9",
    "data-name": "\\uC0AC\\uAC01\\uD615 9",
    transform: "translate(155 92)",
    fill: "#5505d5",
    stroke: "#5605d5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 572,
    rx: 169,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 571,
    height: 571,
    rx: 168.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_1",
    "data-name": "\\uD569\\uCE58\\uAE30 1",
    d: "M-2952.22-6366.584l-60.321-202.421h-1.739l-59.741,202.421h-66.12l-25.745-92.72H-3247.5v-41h70.229l-11.662-42H-3247.5v-41h47.183l-22.763-81.98h70.759l52.781,213.441h2.32l60.321-213.441h54.519l60.9,213.441h2.32l31.66-128.032v-3.429h.848l20.272-81.98,3.537-16-42.317-1L-2811.8-6753l39.683,111.362-33.368-23.646-22.6,81.98h55.584v41h-66.889l-11.581,42h78.47v41h-89.775l-25.565,92.72Z",
    transform: "translate(3455 6910.805)",
    fill: "#ffba00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostav);
export default __webpack_public_path__ + "static/media/costav.cbed9d7299c4eafa195f5217088c1fb2.svg";
export { ForwardRef as ReactComponent };